import {makeBFFApiUrl} from 'main/factories/http';
import {BeneficiaryEndpoints} from 'main/factories/usecases';
import {FeaturesEnum} from 'presentation/constants';
import {getFeatureFlagValue} from './get-feature-flag-value';

export function getLoginTokenEndpoints() {
	const isV4 = getFeatureFlagValue(FeaturesEnum.PORTAL_FEATURE_PLANS_V4);

	const plansEndpoint = isV4 ? BeneficiaryEndpoints.planListV4 : BeneficiaryEndpoints.planListV3;

	const endpointsThatUseLoginToken: string[] = [
		makeBFFApiUrl(BeneficiaryEndpoints.beneficiaryListV3),
		makeBFFApiUrl(plansEndpoint),
		makeBFFApiUrl(BeneficiaryEndpoints.beneficiarySelection),
	];

	return endpointsThatUseLoginToken;
}
